import React, {useCallback, useState} from 'react'
import {Headers, SortKeys, SortOrder} from '../types'
import {Post} from '../../../../../setup'
import {Contact, useContactsContext} from '../../../../../app/@types'
import {THead} from '../components/THead'
import {Pagination} from '../../../content/pagination/Pagination'
import {Tooltip, Whisper} from 'rsuite'
import {KTSVG} from '../../../../helpers'
import {SelectAll} from '../../../../../app/@components'
import {Search} from '../../../content/forms'
import {usePaginatedData, useSearchedData, useSortedData} from '../../../../../app/features'
import {Row} from './Row'

const headers: Headers<Contact>[] = [
    {key: 'created_at', label: 'Date', className: 'fw-bolder text-muted bg-light min-w-150px'},
    {key: 'email', label: 'E-mail', className: 'fw-bolder text-muted bg-light min-w-150px'},
    {key: 'first_name', label: 'Nom', className: 'fw-bolder text-muted bg-light min-w-150px'},
    {key: 'last_name', label: 'Prénom', className: 'fw-bolder text-muted bg-light min-w-150px'},
    {key: 'number', label: 'Téléphone', className: 'fw-bolder text-muted bg-light min-w-125px'},
]
const REMOVE_CONTACTS_FROM_LIST = process.env.REACT_APP_MAILING_REMOVE_CONTACTS_FROM_LIST || 'v2/subscribers-delete-list-contact'

const TablesWidget15 = ({contacts}: {contacts: Contact[]}) => {

    const {triggerReload} = useContactsContext()

    const [sortKey, setSortKey] = useState<SortKeys<Contact>>('created_at')
    const [sortOrder, setSortOrder] = useState<SortOrder>('desc')
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [selectedItems, setSelectedItems] = useState<number[]>([])
    const [selectAll, setSelectAll] = useState<boolean>(false)

    const dataSorted: Contact[] = useSortedData({
        data: contacts, sortKey, reverse: sortOrder === 'desc'
    })
    const {searchedData, setSearchQuery} = useSearchedData<Contact>({
        data: dataSorted,
    })
    const paginatedData = usePaginatedData<Contact>({
        currentPage, itemsPerPage, data: searchedData,
    })

    const handleCheckboxChange = (id: number) => {

        let updatedSelectedItems
        if (selectedItems.includes(id)) {
            updatedSelectedItems = selectedItems.filter(itemId => itemId !== id)
        } else {
            updatedSelectedItems = [...selectedItems, id]
        }
        setSelectedItems(updatedSelectedItems)
        setSelectAll(updatedSelectedItems.length === paginatedData.length)
    }

    const handleRemove = useCallback(async (id?: number) => {

        const itemsToDelete = id ? [id] : selectedItems

        if (itemsToDelete.length === 0) return

        const data = {subscribers: itemsToDelete}

        try {
            const {status} = await Post<{status: number}>(REMOVE_CONTACTS_FROM_LIST, data)
            if (status === 200) {
                triggerReload()
                if (!id) {
                    setSelectedItems([])
                    setSelectAll(false)
                }
            }
        } catch (error) {
            console.error('Error removing contacts:', error)
        } finally {
        }
    }, [selectedItems, triggerReload])

    return (
        <>
            <div className="row d-flex justify-content-between align-items-center mb-5">
                <div className="col-2 col-md-1 d-flex justify-content-between align-items-center">
                    <SelectAll selectAll={selectAll}
                               setSelectAll={setSelectAll}
                               setSelectedItems={setSelectedItems}
                               data={paginatedData}
                    />
                    <Whisper placement="top" controlId="control-id-click" trigger="hover"
                             speaker={(<Tooltip>Supprimer</Tooltip>)}
                    >
                        <button className="btn btn-sm btn-icon btn-active-light-danger"
                                onClick={() => handleRemove()}
                                disabled={(!selectedItems.length)}
                        >
                            <KTSVG path="/media/icons/duotune/general/gen027.svg"
                                   className="svg-icon-2 svg-icon-danger"
                            />
                        </button>
                    </Whisper>
                </div>
                <div className="col-9 col-md-5">
                    <Search setSearchInput={setSearchQuery} />
                </div>
            </div>
            <div className="table-responsive">
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                    <THead headers={headers}
                           sortKey={sortKey}
                           setSortKey={setSortKey}
                           sortOrder={sortOrder}
                           setSortOrder={setSortOrder}
                           firstChildren={<th className="min-w-50px" />}
                           children={<th className="min-w-100px" />}
                    />

                    <tbody>
                    <Row data={paginatedData}
                         selectedItems={selectedItems}
                         handleCheckboxChange={handleCheckboxChange}
                         handleRemove={handleRemove}
                    />
                    </tbody>
                </table>

                <Pagination itemsPerPage={itemsPerPage}
                            totalItems={paginatedData.length}
                            setCurrentPage={setCurrentPage}
                            setItemsPerPage={setItemsPerPage}
                />

            </div>
        </>
    )
}

export {TablesWidget15}